/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class AuditTypeComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: []
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    if (!this.props.section && this.props.loadAll === false) return;
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];
    try {
      items = this.props.loadAll
        ? await this.repository.getTypes()
        : await this.repository.getTypes(this.props.section);

      if (this.props.loadAll) {
        const map = new Map();
        const result = [];
        items.map((item) => {
          if (!map.has(item.name)) {
            map.set(item.name, true);
            result.push({ name: item.name });
          }
          return null;
        });
        items = result;
      }
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxAuditType"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a Type"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name?.toLowerCase().includes(inputValue?.toLowerCase()) ||
          item.code?.toLowerCase().includes(inputValue?.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        initialSelectedItem={this.props.initialSelectedItem}
      />
    );
  }
}

AuditTypeComboBox.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  section: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  loadAll: PropTypes.bool,
  initialSelectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
AuditTypeComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  section: null,
  loadAll: false,
  initialSelectedItem: null,
  disabled: true
};
